import React from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Link,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";

const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          mt: 8,
          mb: 8,
          p: 6,
          borderRadius: 3,
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Privacy Policy
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Capitaland DataForge ("we", "our", "us") operates the Capitaland DataForge
          Application accessible at{" "}
          <Link
            href="https://app.bimageconsulting.com"
            target="_blank"
            rel="noopener"
          >
            https://app.bimageconsulting.com
          </Link>.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 1 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          1. Information We Collect
        </Typography>

        <Typography variant="subtitle1" fontWeight="medium">
          When users authenticate using Google, we may collect:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Name" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Email address" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Google account ID" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Access tokens required for integration" />
          </ListItem>
        </List>

        <Typography variant="subtitle1" fontWeight="medium" sx={{ mt: 2 }}>
          If users connect Google Drive, we may access:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Files and metadata explicitly selected by the user" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Files created or managed through our application" />
          </ListItem>
        </List>

        <Typography variant="body2" sx={{ mt: 1 }}>
          We do not access files without user authorization.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 2 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          2. How We Use Information
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Authenticate users" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Enable integration with Google Drive" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Allow reading, writing, or processing of selected files" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Provide application functionality" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Improve system performance and security" />
          </ListItem>
        </List>

        <Divider sx={{ my: 3 }} />

        {/* Section 3 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          3. Data Storage
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Access tokens are securely stored." />
          </ListItem>
          <ListItem>
            <ListItemText primary="We do not sell, rent, or share user data with third parties." />
          </ListItem>
          <ListItem>
            <ListItemText primary="File content is only processed as required by user action." />
          </ListItem>
        </List>

        <Divider sx={{ my: 3 }} />

        {/* Section 4 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          4. Data Sharing
        </Typography>
        <Typography variant="body1">
          We do not share Google user data with third parties except:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="When required by law" />
          </ListItem>
          <ListItem>
            <ListItemText primary="To provide requested services" />
          </ListItem>
        </List>

        <Divider sx={{ my: 3 }} />

        {/* Section 5 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          5. Data Security
        </Typography>
        <Typography variant="body1">
          We implement appropriate security measures to protect user data
          against unauthorized access, alteration, or disclosure.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 6 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          6. User Rights
        </Typography>
        <Typography variant="body1">
          Users may revoke access at any time via:
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Google Account → Security → Third-party apps.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 7 */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          7. Contact Information
        </Typography>
        <Typography variant="body1">
          If you have questions about this Privacy Policy, contact:
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Link
            href="mailto:support@bimageconsulting.com"
            underline="hover"
          >
            support@bimageconsulting.com
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicyPage;